// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"62":"brand-rigging","155":"brand-danfloss"}[chunkId] || chunkId) + "." + {"62":"3f2b9fce","148":"90076712","155":"a9a69aa0","217":"47f725f9","782":"2ca2be2b"}[chunkId] + ".chunk.js";
};